import React from "react";
import { getCurrentErrorsOptions, getCurrentLanguage } from "../../../../utils/software";

import DisplayErrorsList from "./displayerrorslist";

export default class ErrorsList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            resultat: null
        };

        this.worker = null;
        this.propsChanged = false;
        this.lastProps = props;
    }

    componentDidMount() {

        this.worker = new Worker(
            new URL("./errorsworker.js", import.meta.url)
        );

        this.worker.onmessage = (e) => {
            this.setState({
                resultat: e.data.errorSubtitles
            });
        };

        // Vérifie toutes les 2 secondes
        this.timer = setInterval(() => {

            if ((this.propsChanged) && (this.props.visible)) {

                this.propsChanged = false;
                
                const datas = {
                    subtitles: this.props.subtitles,
                    stparams: this.props.stparams,
                    timecodeasset: this.props.timecodeasset,
                    language: getCurrentLanguage(),
                    errorsoptions: getCurrentErrorsOptions(),
                    displayms: false,
                }
                this.worker.postMessage(datas);
            }

        }, 2000);
    }

    componentDidUpdate(prevProps) {

        // Détection d'un changement de props
        if (prevProps !== this.props) {
            this.propsChanged = true;
            this.lastProps = this.props;
        }

    }

    componentWillUnmount() {

        clearInterval(this.timer);

        if (this.worker) {
            this.worker.terminate();
        }

    }

    render() {
        
        if (!this.props.visible) return (<></>);
        return (
            <div style={{height:"calc( 100% - 25px)", width:"100%"}}>
                <DisplayErrorsList data = {this.state.resultat} onClick = {this.props.onClick} current = {this.props.current} />
            </div>
        );

    }

}